import { render, staticRenderFns } from "./ContributionLogs.vue?vue&type=template&id=72437b6d&scoped=true&"
import script from "./ContributionLogs.vue?vue&type=script&lang=js&"
export * from "./ContributionLogs.vue?vue&type=script&lang=js&"
import style0 from "./ContributionLogs.vue?vue&type=style&index=0&id=72437b6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72437b6d",
  null
  
)

/* custom blocks */
import block0 from "./ContributionLogs.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports